// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"10eb6cb0","96":"28a90b3c","233":"f9ed7ddc","453":"4bcdc434","469":"a33f3016","731":"c1e66773","922":"fde28a71"}[chunkId] + ".chunk.js";
};